import React from 'react';

const LoadingSpinner = ({
                          size = 'auto',
                          color = 'primary',
                          fullHeight = false
                        }) => {
  const sizeClass = size === 'auto' ? 'spinner-auto' : `spinner-${size}`;
  const colorClass = `spinner-${color}`;
  const heightClass = fullHeight ? 'full-height' : '';

  return (
    <div className={`spinner-container ${sizeClass} ${colorClass} ${heightClass}`}>
      <div className="spinner"></div>
    </div>
  );
};

export default LoadingSpinner;
